module.exports = __webpack_public_path__ + "img/beginConnect.0bdd016e.png";